var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.encrypted)?_c('span',{staticClass:"mx-1 bg-blue-lighter"},_vm._l((_vm.length),function(key){return _c('span',{key:key},[_vm._v("X")])}),0):_c('span',{staticClass:"mx-1"},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }